module.exports = __webpack_public_path__ + "fonts/roboto-medium-webfont.d5e6a03.woff2";